module.exports = __webpack_public_path__ + "static/media/callharbour-logo.08daaea0.png";